
export const COLORS = {
    // primary: '#008a4f',
    primary: 'linear-gradient(90deg, rgb(3, 13, 51), rgb(0, 53, 55), rgb(0 0 0))',
    // primary: '#00BFA5',
    secondary: '#E0F7F5',
    text: {
      primary: '#333333',
      secondary: '#666666',
      light: '#FFFFFF'
    },
    background: {
      main: '#FFFFFF',
      secondary: '#E0F7F5',
      gradient: 'linear-gradient(180deg, #E0F7F5 0%, #FFFFFF 100%)'
    },
    border: '#E8E8E8',
    // backgroundImage: "linear-gradient(90deg, #030d33, #003537, transparent)"
  };
  
  export const SIZES = {
    spacing: {
      xs: '8px',
      sm: '16px',
      md: '24px',
      lg: '32px',
      xl: '48px',
      xxl: '64px'
    },
    container: {
      sm: '600px',
      md: '960px',
      lg: '1280px'
    },
    borderRadius: {
      sm: '4px',
      md: '8px',
      lg: '16px',
      xl: '24px'
    },
    fontSize: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '24px',
      xl: '32px',
      xxl: '48px'
    }
  };
  
  export const BREAKPOINTS = {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  };
  
  export const MOCK_PRODUCTS = [
    {
      id: 1,
      name: 'New Rectangle Unisex Black',
      price: 89.00,
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    },
    {
      id: 2,
      name: 'Grey Cottral Rimmed',
      price: 99.00,
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    },
    {
      id: 3,
      name: 'Black Square Unisex',
      price: 79.00,
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    },
    {
      id: 4,
      name: 'Blue Rectangle Women',
      price: 89.00,
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    }
  ];
  
  export const BLOG_POSTS = [
    {
      id: 1,
      title: 'Guidance on how to choose the perfect sunglasses',
      date: 'January 6, 2024',
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    },
    {
      id: 2,
      title: 'Information on the importance of eye protection',
      date: 'January 8, 2024',
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    },
    {
      id: 3,
      title: 'The blog could discuss the latest trends',
      date: 'January 10, 2024',
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    },
    {
      id: 4,
      title: 'Posts might discuss the history of eyewear',
      date: 'January 12, 2024',
      image: 'https://goggles-workdo.myshopify.com/cdn/shop/files/Group38386_440x466.png?v=1699276409'
    }
  ];
  